<template>
  <div class="lg:min-w-[350px]">
    <label
      class="mb-1.5 inline-block font-sans text-base text-black lg:mb-3 lg:text-lg lg:leading-snug"
      :class="styleLabel"
    >
      {{ label }}
    </label>
    <RadioButton
      v-for="option in options"
      :key="option.value"
      v-model="modelValueModel"
      :label="option.label"
      :value="option.value"
      :sub-title="option.subTitle"
      :theme="theme"
    />
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import RadioButton from '../atoms/RadioButton.vue'
import type { IOption } from '../../types'
import { THEMES } from '../../types/themes'

const props = withDefaults(
  defineProps<{
    label?: string
    styleLabel?: string
    options: IOption[]
    name?: string
    modelValue: string | number
    theme?: THEMES
  }>(),
  {
    theme: THEMES.DEFAULT,
  },
)

const emits = defineEmits(['update:modelValue'])
const modelValueModel = useVModel(props, 'modelValue', emits)
</script>
